import { computed } from 'vue';

import { useSsoStore } from '@/stores/sso';

import { useSsoLabels } from './useSsoLabels';

/** The welcome text for a logged in sso user, e.g. "Velkommen Anne Hansen" (the name, or the email when there is no name). */
export function useSsoWelcomeText() {
  const { welcomeLabel } = useSsoLabels();
  const ssoStore = useSsoStore();

  return computed(() => `${welcomeLabel.value} ${ssoStore.userName.trim() || ssoStore.userEmail}`);
}
